import assetPath from '/app/xinglets/lebenslauf/pages/startpage/src/assets/cover-letter-bg-mobile.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')